<template>
    <section class="investors-access" id="funding" data-anchor="funding">

        <div class="form-container">

            <transition name="fade-up">
                <div class="thank-block" v-if="isFormSended">

                    <h2 class="is-small is-centered">Special Access <br> for Investors</h2>

                    <img src="@/assets/images/icons/CheckMark_large.svg" alt="large check mark">

                    <h3 class="is-small">Your request has <br> been sent. <br><br> Thank you!</h3>

                </div>
            </transition>

            <form v-if="!isFormSended" @submit.prevent="sendForm" id="invest_access_form">

                <h2 class="is-small is-centered">Special Access <br> for Investors</h2>

                <v-input placeholder="Name"
                         v-model="formData.name"
                >
                </v-input>

                <v-input placeholder="Email"
                         v-model="formData.email"
                >
                </v-input>

                <v-input placeholder="Message"
                         is-textarea
                         v-model="formData.message"
                >
                </v-input>

                <button class="btn is-narrow"
                        type="submit"
                >
                    get special access
                </button>

            </form>

        </div>

        <div class="image-container parallax-parent">

            <ParallaxBlock unique-class="investors_dotes"
                           :speed="-0.15"
                           image="dotes_12x18"
            >
            </ParallaxBlock>

        </div>

    </section>
</template>

<script>
    export default {
        name: "InvestorsAccess",
        data() {
            return {
                formData: {
                    name: '',
                    email: '',
                    message: ''
                },
                isFormSended: false
            }
        },
        methods: {
            sendForm() {
                const params = { 
                    investor: this.formData,
                    authenticity_token: this.$cookies.get('form_authenticity_token')
                }
                this.$axios.post("/investors", params).then(() => { this.isFormSended = true })
            }
        }
    }
</script>